import React, { useCallback, useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./slick.css";
import "./slick-theme.css";
import {
  CategoryData,
  AccessoriesData,
  MenShoesSubcategoryData,
  MenBagsSubcategoryData,
  WomenShoesSubcategoryData,
  WomenBagsSubcategoryData,
} from "./slider-data";
import style from "./CategoryPage.module.css";
import Products from "./Products";
import styles from "./Products.module.css";
import accessories from "../images/accessories.jpg"
import men_banner from "../images/men_gategory.png";
import women_banner from "../images/women_banner.png";

export const ProductsList = ({ items }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };
  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
        <FaArrowRight className="arrow next" onClick={nxetSlide} />
      </div>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
        <FaArrowLeft className="arrow prev" onClick={prevSlide} />
      </div>
    );
  };

  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className={styles.Products_container}>
      <Slider {...settings}>
        {items.map((item) => {
          return (
            <div key={item.title}>
              <Products {...item} />
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export const CategorySlide = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;
  let slidesToShow = 3;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 3;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 3;
  } else {
    slidesToShow = 3;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };
  const MenImage = () => {
    return (
      <div className={styles.banner}>
        <img src={accessories} alt="men banner" />
      </div>
    );
  };
  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (slide) => {
      if (slide.Category === "Watches") {
        navigate("/watches");
      } else if (slide.Category === "Jewellery") {
        navigate("/jewellery");
      } else if (slide.Category === "Glasses") {
        navigate("/glasses");
      } else if (slide.Category === "Unisex") {
        navigate("/categoryUnisex");
      }
    },
    [navigate]
  );

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: slidesToShow,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div >
      <Slider {...settings}>
        {AccessoriesData.map((slide, index) => {
          return (
            <div
              className={style.container}
              key={index}
              onClick={() => handleOnClick(slide)}
            >
              <>
                <div className={style.item}>
                  <img src={slide.image} alt="slide" />
                  <h3>{slide.Name}</h3>
                </div>
              </>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export const CategorySlideHome = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;
  let slidesToShow = 3;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 3;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 3;
  } else {
    slidesToShow = 3;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };
  const MenImage = () => {
    return (
      <div className={styles.banner}>
        <img src={accessories} alt="men banner" />
      </div>
    );
  };
  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (slide) => {
      if (slide.Category === "Watches") {
        navigate("/watches");
      } else if (slide.Category === "Jewellery") {
        navigate("/jewellery");
      } else if (slide.Category === "Glasses") {
        navigate("/glasses");
      } else if (slide.Category === "Unisex") {
        navigate("/categoryUnisex");
      }
    },
    [navigate]
  );

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: slidesToShow,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className={styles.container}>
      <Link className={styles.men_link} to="/categoryUnisex">
        <div className={styles.women_text}>
          <h1>Accessories</h1>
        </div>
        <div className={`${styles.text}, ${styles.category_text}`}>
          <h1>Category</h1>
        </div>
      </Link>
      <MenImage />
      <Slider {...settings}>
        {AccessoriesData.map((slide, index) => {
          return (
            <div
              className={style.container}
              key={index}
              onClick={() => handleOnClick(slide)}
            >
              <>
                <div className={style.item}>
                  <img src={slide.image} alt="slide" />
                  <h3>{slide.Name}</h3>
                </div>
              </>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export const CategoryForMen = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;
  let slidesToShow = 5;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 3;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 4;
  } else {
    slidesToShow = 5;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };
  const MenImage = () => {
    return (
      <div className={styles.banner}>
        <img src={men_banner} alt="men banner" />
      </div>
    );
  };
  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (slide) => {
      if (slide.Category === "Shoes") {
        navigate("/shoesProductsForMen");
      } else if (slide.Category === "Wallet") {
        navigate("/walletsProductsForMen");
      } else if (slide.Category === "Clothes") {
        navigate("/clothesproductsformen");
      } else if (slide.Category === "Perfumes") {
        navigate("/perfumesformen");
      } else if (slide.Category === "Bags") {
        navigate("/bagsformen");
      }
    },
    [navigate]
  );

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: slidesToShow,
    slidesToShow: 6,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className={styles.container}>
      <Link className={styles.men_link} to="/products-men">
        <div className={styles.women_text}>
          <h1>Men</h1>
        </div>
        <div className={`${styles.text}, ${styles.category_text}`}>
          <h1>Category</h1>
        </div>
      </Link>
      <MenImage />
      <Slider {...settings}>
        {CategoryData.map((slide, index) => {
          return (
            <div
              className={style.container}
              key={index}
              onClick={() => handleOnClick(slide)}
            >
              <>
                <div className={style.item}>
                  <img src={slide.image} alt="slide" />
                  <h3>{slide.Category}</h3>
                </div>
              </>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export const CategorySlideForMen = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;
  let slidesToShow = 5;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 3;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 4;
  } else {
    slidesToShow = 5;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };
  const MenImage = () => {
    return (
      <div className={styles.banner}>
        <img src={men_banner} alt="men banner" />
      </div>
    );
  };
  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (slide) => {
      if (slide.Category === "Shoes") {
        navigate("/shoesProductsForMen");
      } else if (slide.Category === "Wallet") {
        navigate("/walletsProductsForMen");
      } else if (slide.Category === "Clothes") {
        navigate("/clothesproductsformen");
      } else if (slide.Category === "Perfumes") {
        navigate("/perfumesformen");
      } else if (slide.Category === "Bags") {
        navigate("/bagsformen");
      }
    },
    [navigate]
  );

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: slidesToShow,
    slidesToShow: 6,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div >
      <Slider {...settings}>
        {CategoryData.map((slide, index) => {
          return (
            <div
              className={style.container}
              key={index}
              onClick={() => handleOnClick(slide)}
            >
              <>
                <div className={style.item}>
                  <img src={slide.image} alt="slide" />
                  <h3>{slide.Category}</h3>
                </div>
              </>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export const CategoryForWomen = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;
  let slidesToShow = 5;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 3;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 4;
  } else {
    slidesToShow = 5;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };

  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (slide) => {
      if (slide.Category === "Shoes") {
        navigate("/shoesProductsForWomen");
      } else if (slide.Category === "Wallet") {
        navigate("/walletsProductsForWomen");
      } else if (slide.Category === "Clothes") {
        navigate("/clothesproductsforwomen");
      } else if (slide.Category === "Perfumes") {
        navigate("/perfumesforwomen");
      } else if (slide.Category === "Bags") {
        navigate("/bagsforwomen");
      }
    },
    [navigate]
  );
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: slidesToShow,
    slidesToShow: slidesToShow,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className={styles.container}>
      <Link className={styles.men_link} to="/products-women">
        <div className={styles.women_text}>
          <h1>Women</h1>
        </div>
        <div className={`${styles.text}, ${styles.category_text}`}>
          <h1>Category</h1>
        </div>
      </Link>
      <div className={styles.banner}>
        <img src={women_banner} alt="women banner" />
      </div>
      <Slider {...settings}>
        {CategoryData.map((slide, index) => {
          return (
            <div
              className={style.container}
              key={index}
              onClick={() => handleOnClick(slide)}
            >
              <>
                <div className={style.item}>
                  <img src={slide.image} alt="slide" />
                  <h3>{slide.Category}</h3>
                </div>
              </>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};
export const CategorySlideForWomen = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;
  let slidesToShow = 5;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 3;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 4;
  } else {
    slidesToShow = 5;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };

  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (slide) => {
      if (slide.Category === "Shoes") {
        navigate("/shoesProductsForWomen");
      } else if (slide.Category === "Wallet") {
        navigate("/walletsProductsForWomen");
      } else if (slide.Category === "Clothes") {
        navigate("/clothesproductsforwomen");
      } else if (slide.Category === "Perfumes") {
        navigate("/perfumesforwomen");
      } else if (slide.Category === "Bags") {
        navigate("/bagsforwomen");
      }
    },
    [navigate]
  );
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: slidesToShow,
    slidesToShow: slidesToShow,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div>
      <Slider {...settings}>
        {CategoryData.map((slide, index) => {
          return (
            <div
              className={style.container}
              key={index}
              onClick={() => handleOnClick(slide)}
            >
              <>
                <div className={style.item}>
                  <img src={slide.image} alt="slide" />
                  <h3>{slide.Category}</h3>
                </div>
              </>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export const MenShoesSubcategorySlide = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;
  let slidesToShow = 4;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 3;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 4;
  } else {
    slidesToShow = 4;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };

  const handleOnClick = useCallback(
    (slide) => {
      switch (slide.Subcategory) {
        case "loafers":
          navigate("/loafers-for-men");
          break;
        case "sneakers":
          navigate("/sneakers-for-men");
          break;
        case "slides":
          navigate("/slides-for-men");
          break;
        case "yeezys":
          navigate("/yeezys-for-men");
          break;
        default:
          break;
      }
    },
    [navigate]
  );

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: slidesToShow,
    slidesToShow: slidesToShow,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className={styles.sub_container}>
      <Slider {...settings}>
        {MenShoesSubcategoryData.map((slide, index) => {
          return (
            <div
              className={style.container}
              key={index}
              onClick={() => handleOnClick(slide)}
            >
              <>
                <div className={style.item}>
                  <img src={slide.image} alt="slide" />
                  <h3>{slide.Subcategory}</h3>
                </div>
              </>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export const MenBagsSubcategorySlide = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;
  let slidesToShow = 6;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 3;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 4;
  } else {
    slidesToShow = 6;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };

  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (slide) => {
      if (slide.Subcategory === "messengers") {
        navigate("/messengers-for-men");
      } else if (slide.Subcategory === "duffles") {
        navigate("/duffles-for-men");
      } else if (slide.Subcategory === "back-packs") {
        navigate("/back-packs-for-men");
      } else if (slide.Subcategory === "slings") {
        navigate("/slings-for-men");
      } else if (slide.Subcategory === "satchels") {
        navigate("/satchels-for-men");
      } else if (slide.Subcategory === "belt-bags") {
        navigate("/belt-bags-for-men");
      }
    },
    [navigate]
  );

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: 4,
    slidesToShow: slidesToShow,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className={styles.sub_container}>
      <Slider {...settings}>
        {MenBagsSubcategoryData.map((slide, index) => {
          return (
            <div
              className={style.container}
              key={index}
              onClick={() => handleOnClick(slide)}
            >
              <>
                <div className={style.item}>
                  <img src={slide.image} alt="slide" />
                  <h3>{slide.Subcategory}</h3>
                </div>
              </>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export const WomenShoesSubcategorySlide = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;
  let slidesToShow = 4;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 3;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 4;
  } else {
    slidesToShow = 5;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };

  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (slide) => {
      if (slide.Subcategory === "espadrilles") {
        navigate("/espadrilles-for-women");
      } else if (slide.Subcategory === "sneakers") {
        navigate("/sneakers-for-women");
      } else if (slide.Subcategory === "slides") {
        navigate("/slides-for-women");
      } else if (slide.Subcategory === "heels") {
        navigate("/heels-for-women");
      } else if (slide.Subcategory === "sandals") {
        navigate("/sandals-for-women");
      }
    },
    [navigate]
  );

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: slidesToShow,
    slidesToShow: slidesToShow,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className={styles.sub_container}>
      <Slider {...settings}>
        {WomenShoesSubcategoryData.map((slide, index) => {
          return (
            <div
              className={style.container}
              key={index}
              onClick={() => handleOnClick(slide)}
            >
              <>
                <div className={style.item}>
                  <img src={slide.image} alt="slide" />
                  <h3>{slide.Subcategory}</h3>
                </div>
              </>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export const WomenBagsSubcategorySlide = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = Products.length;
  let slidesToShow = 4;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 3;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 4;
  } else {
    slidesToShow = 4;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);
  // Custom next arrow component
  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  // Custom previous arrow component
  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };

  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (slide) => {
      if (slide.Subcategory === "totes") {
        navigate("/totes-for-women");
      } else if (slide.Subcategory === "shoulder-cross-body") {
        navigate("/shoulder-cross-body-for-women");
      } else if (slide.Subcategory === "mini-bags") {
        navigate("/mini-bags-for-women");
      } else if (slide.Subcategory === "clutches") {
        navigate("/clutches-for-women");
      }
    },
    [navigate]
  );

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: slidesToShow,
    slidesToShow: slidesToShow,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className={styles.sub_container}>
      <Slider {...settings}>
        {WomenBagsSubcategoryData.map((slide, index) => {
          return (
            <div
              className={style.container}
              key={index}
              onClick={() => handleOnClick(slide)}
            >
              <>
                <div className={style.item}>
                  <img src={slide.image} alt="slide" />
                  <h3>{slide.Subcategory}</h3>
                </div>
              </>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};
